import { FireOpenForwardWebsocketMessageRequestDto } from './fireOpenForwardWebsocketMessageRequest.dto';

export class FireOpenForwardWebsocketMessageResponse {
  success: boolean;
  message: string;
  request: FireOpenForwardWebsocketMessageRequestDto;
}
